import { translate, parseKeyword, keywordText } from '../../ContentTranslation';
import React, { Component } from 'react';
import './CardBox.css';
import Card from './Card';
import Hero from './Hero';
import Champion from './Champion';
import Ability from './Ability';
import Lightbox from '../utility/Lightbox';
import { Tooltip } from 'reactstrap';
import Library from '../../scene/utility/Library';
import Img from '../../StableImage';
import User from '../../User';

import { read, getLanguage } from '../../TextManager';
import { getMusic, play, stopMusic } from '../../SoundManager';

const statuses = Object.values(Library.statuses);
const lang = getLanguage();

export default class CardBox extends Component {

	state={ token: [], mask: false, tier: this.props.tier || 0 }

	constructor (props) {

		super (props);

		this.state.level = props.level;
	}

	  _handleKeyDown = event => {
	    if (!this.props.open || (event.key !== 'm' && event.key !== 'M'))
	      return;
	    event.preventDefault();
	    event.stopPropagation();
	    this.setState(state => ({mask: !state.mask}));
	  }

	  componentDidMount () {
	    document.addEventListener("keydown", this._handleKeyDown);
	  }

	  componentWillUnmount () {

	    document.removeEventListener("keydown", this._handleKeyDown);
	  }

	  toggleTooltip (tooltip, touch) {

	  	if (touch) {

		    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
		      return;

		    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
		}

		this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
	  }

	get current () {

		if (this.state.token.length > 0)
			return this.state.token[this.state.token.length - 1];

		let tier = this.state.tier || this.props.src.tier || 0;

		if (tier)
			return Object.assign({}, this.props.src, this.props.src.upgrades[tier-1]);

		return this.props.src;
	}

	toRoman(num) {
	  const romanMap = [
	    { value: 1000, numeral: "M" },
	    { value: 900, numeral: "CM" },
	    { value: 500, numeral: "D" },
	    { value: 400, numeral: "CD" },
	    { value: 100, numeral: "C" },
	    { value: 90, numeral: "XC" },
	    { value: 50, numeral: "L" },
	    { value: 40, numeral: "XL" },
	    { value: 10, numeral: "X" },
	    { value: 9, numeral: "IX" },
	    { value: 5, numeral: "V" },
	    { value: 4, numeral: "IV" },
	    { value: 1, numeral: "I" },
	  ];

	  let result = "";

	  for (const { value, numeral } of romanMap) {
	    while (num >= value) {
	      result += numeral;
	      num -= value;
	    }
	  }

	  return result;
	}

	computeEffect (other) {

		let current = this.current;

		if (!other && !current.effect && !current.passive)
			return [];
		let text = (other || current.effect || current.passive.effect).replace(/##/g, "");
		let splits = [];
	    // eslint-disable-next-line
	    let texts = text.split(/\[[^\[]+\]|\{[^\{]+\}|\<[^\<]+\>|\n|D:\d+|B:\d+|M:\d+|F:\d+/);
	    // eslint-disable-next-line
	    let matches = text.match(/\[[^\[]+\]|\{[^\{]+\}|\<[^\<]+\>|\n|D:\d+|B:\d+|M:\d+|F:\d+/g);
		if (matches)
			matches.forEach((match,i) => {
				let el = match.slice(1, -1);
				splits.push(<span key={i+"a"}>{ texts[i] }</span>);
				if (match[0] === '{') {
					let slices = el.split(':');
					let key = slices[0];
					let ntoken = this.state.token.slice();
					let tokentoadd = Library.cards[key];
					if (slices.length > 1)
						tokentoadd = Object.assign({}, tokentoadd, tokentoadd.upgrades[parseInt(slices[1],10)-2]);
					ntoken.push(tokentoadd);
					let repeat = current.key && key === current.key.toString();
					splits.push(<span onClick={repeat ? () => {} : () => this.setState({tooltip: null, token: ntoken})} key={i} className={"token" + (repeat ? " repeat-token" : "")} id={'effect-' + i}>{ Library.cards[key].name }</span>);
				} else if (match[0] === '[') {
					const { keyword } = parseKeyword(el);
					let status = statuses.filter(s => s.translations && s.translations.en.name === keyword)[0];
					splits.push(<span key={i} className={"keyword" + (status.translations[lang].effect ? "" : " unlabelled") + (status.soft ? " soft" : "")} id={'effect-' + i} onPointerDown={e => this.toggleTooltip(i, e.pointerType === "touch")}>{status.keyword ? "" : <Img key={keyword + "-" + i} className={"keyword-icon" + (read('system/nospaces') ? " nospaces" : "")} src={"/images/statuses/" + keyword + ".png"} alt=""/>}{keywordText(el, lang, status.translations[lang].name)}</span>);
					if (status.translations[lang].effect)
						splits.push(<Tooltip key={i+"t"} className="tooltip" placement="top" isOpen={this.state.tooltip === i} target={"effect-" + i} toggle={() => this.toggleTooltip(i)}>{ status.translations[lang].effect }</Tooltip>);
					
				} else if (match[0] === '<') {
					let param = el;
					let value = current[param];
					let className = "";
					if (param.includes("damage"))
						className = "num-effect damage-effect";
					else if (param.includes("block"))
						className = "num-effect block-effect";
					else if (param.includes("momentum"))
						className = "num-effect momentum-effect";
					splits.push(<span key={i} className={className}>{value}</span>);
					
				} else if (match[0] === '\n') {
					splits.push(<br key={i}/>);
			    } else if (match[0] === 'D') {
			      let initialvalue = parseInt(match.substring(2), 10);
			      splits.push(<span key={i} className="num-effect damage-effect">{ initialvalue }</span>);
			    } else if (match[0] === 'B') {
			      let initialvalue = parseInt(match.substring(2), 10);
			      splits.push(<span key={i} className="num-effect block-effect">{ initialvalue }</span>);
			    } else if (match[0] === 'M') {
			      let initialvalue = parseInt(match.substring(2), 10);
			      splits.push(<span key={i} className="num-effect momentum-effect">{ initialvalue }</span>);
			    } else if (match[0] === 'F') {
			      let initialvalue = parseInt(match.substring(2), 10);
			      splits.push(<span key={i} className="num-effect othervalue-effect">{ initialvalue }</span>);
			    }
			});
		splits.push(<span key={"end"}>{ texts[texts.length-1] }</span>);
		return splits;
	}

	renderArtPicker (current) {

		if (!current?.key || User.cardArtModeFor(current.champion || User.champion) !== 'manual')
			return "";
		const arts = Library.getUnlockedCardArts(current);
		if (arts.length === 0)
			return "";
		const selected = Library.getSelectedCardArt(current);
		return (
			<div className="cardbox-art-picker">
				{arts.map((art, i) =>
					<button
						key={art.img}
						type="button"
						className={"cardbox-art-option" + (art.img === selected ? " selected" : "")}
						aria-label={translate("Select card art ") + (i + 1)}
						onClick={() => {
							User.selectCardArt(current.key, art.img);
							if (art.img === selected) {
								this.setState({artPreview: art.img});
								return;
							}
							this.forceUpdate();
						}}
					>
						<Img src={art.img} alt=""/>
					</button>
				)}
			</div>
		);
	}

	renderItem () {

		let current = this.current;
		let celestial = current.pool && ['amaryllis', 'aurora', 'bulubulu', 'zephyrus'].includes(current.pool);

		return(
			<Lightbox className={"cardbox-focus-box card-box" + (this.state.mask ? " opaque" : "")} open={this.props.open} onClose={this.props.onClose}>
	          <div className={"cardbox-focus item-focus"}>
	            <div className="cardbox-focus-item"><Img key={"cardbox-focus-" + current.img} src={current.img}/></div>
	            <h1 className={ current.name.length >= 25 ? "small-name" : ""}>{current.name}</h1>
	            {
	            	<div className="card-typing">
	            		{ current.champion && current.pool === "treasure" && <span className="card-rarity">{ "champion" }{read('cards/categoryseparator')}</span> }
                {!read('system/categorylast') && <>{current.subtype === "extra" ? <span className="card-rarity">{read('cards/extra')}{read('cards/categoryseparator')}</span> : current.rarity ? <span className="card-rarity">{ current.rarity === 1 ? read('cards/common') : (current.rarity === 2 ? read('cards/uncommon') : read('cards/rare')) }{read('cards/categoryseparator')}</span> : ""}{current.pool && current.pool !== "treasure" ? <span className="card-rarity">{ read('cards/' + (celestial ? "celestial" : current.pool)) }{read('cards/categoryseparator')}</span> : ""}</>}
	            		<span className="card-type">{ this.props.relic ? read('cards/relic') : read('cards/potion') }</span>
                {read('system/categorylast') && <>{read('cards/categoryseparator')}{current.subtype === "extra" ? <span className="card-rarity">{read('cards/extra')}{read('cards/categoryseparator')}</span> : current.rarity ? <span className="card-rarity">{ current.rarity === 1 ? read('cards/common') : (current.rarity === 2 ? read('cards/uncommon') : read('cards/rare')) }{read('cards/categoryseparator')}</span> : ""}{current.pool && current.pool !== "treasure" ? <span className="card-rarity">{ read('cards/' + (celestial ? "celestial" : current.pool)) }{read('cards/categoryseparator')}</span> : ""}</>}
	            	</div>
	            }
	            <p className={ "game-effect" + (current.effect.length >= 125 ? " small-effect" : "")}>{ this.computeEffect() }</p>
	            {/*<div className="champion-quote"><span>{current.quote}</span></div>*/}
	          </div>
	          { this.props.left && this.state.token.length === 0 && !this.state.mask ? <div onClick={() => this.props.left()} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
	          { this.props.right && this.state.token.length === 0 && !this.state.mask ? <div onClick={() => this.props.right()} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
	        </Lightbox>
		);
	}

	render () {

		let current = this.current;

		window.focus = current;

		if (this.props.item || this.props.relic)
			return this.renderItem();

		let champion = current.fullart !== undefined;
		let colors = current.colors || (current.color ? [current.color] : []);

		let style = undefined;

		let source = this.props.origin || this.props.src;
		let subtypes = Library.cardSubtypes(current);

		let tier = this.state.tier || current.tier || 0;

		let maxTier = current.upgrades && !current.token ? current.upgrades.length : 0;
		/*if (current.upgrades && tier < maxTier && User.data.level < current.upgrades[(User.data.upgrades[current.key] || 1)-1].level)
			maxTier = User.data.upgrades[current.key] || 0;*/

		if (source.style)
			style = {background: "linear-gradient(" + source.style.hud.dark + ", " + source.style.hud.light + ")"}

		return(
			<>
			<Lightbox style={ style } className={"cardbox-focus-box" + (champion ? " champion-box" : " card-box") + (this.state.mask ? " opaque" : "") + (source.style ? " hero-box" : "")} open={this.props.open} onClose={this.props.onClose}>
	          { maxTier > tier && this.props.onUpgrade && <div className="cardbox-upgrade" onClick={() => this.props.onUpgrade()}>{translate("Upgrade")}</div> }
	          <div className={"cardbox-focus" + (champion ? " champion-focus" : "")}>
	            <div className={"cardbox-focus-card" + (champion ? (" cardbox-focus-champion") : "") }>{ champion ? <Champion src={current}/> : <Card src={current} tier={tier}/> }</div>
	            { !champion && maxTier > tier && this.props.onUpgrade && <div className={"cardbox-focus-card cardbox-focus-card-upgrade" + (current.upgrades[tier].mana ? (current.upgrades[tier].mana > ((tier > 0 ? current.upgrades[tier-1].mana : 0) || current.mana) ? " cardbox-focus-card-upgrade-mana" : "") : "")}><Card src={Object.assign({}, current, current.upgrades[tier])} tier={tier+1}/></div> }
	            { !champion && this.renderArtPicker(current) }
	            <h1 className={ (champion ? current.translations[lang].name.length >= 25 : current.name.length >= 25) ? "small-name" : ""}>{champion ? current.translations[lang].name : current.name}</h1>
	            { 	champion ?
	            	<div className="card-typing">
	            		<span className="card-type">{ current.translations[lang].path }</span>
	            	</div>
	            	:
	            	<div className="card-typing">
                {!read('system/categorylast') && <>{current.rarity ? <span className="card-rarity">{ (current.rarity === 5 ? read('cards/extra') : current.rarity === 4 ? read('cards/extra') : (current.rarity === 3 ? read('cards/rare') : (current.rarity === 2 ? read('cards/uncommon') : read('cards/common')))) }{read('cards/categoryseparator')}</span> : ""}{current.starter ? <span className="card-rarity">{ read('cards/basic') }{read('cards/categoryseparator')}</span> : ""}</>}
	            		<span className="card-type">{ read('cards/'+current.type) }</span>
                {read('system/categorylast') && <>{read('cards/categoryseparator')}{current.rarity ? <span className="card-rarity">{ (current.rarity === 5 ? read('cards/extra') : current.rarity === 4 ? read('cards/extra') : (current.rarity === 3 ? read('cards/rare') : (current.rarity === 2 ? read('cards/uncommon') : read('cards/common')))) }{read('cards/categoryseparator')}</span> : ""}{current.starter ? <span className="card-rarity">{ read('cards/basic') }{read('cards/categoryseparator')}</span> : ""}</>}
	            		{ subtypes.map(subtype => <span key={subtype} className="card-type">{read('cards/categoryseparator')}{read('cards/' + subtype)}</span>) }
                { current.token && <span className="card-type">{'\u00a0'}{read('cards/token')}</span> }
	            	</div>
	            }
	            {
	            	champion ?
	            	<p className={ "game-effect" + (current.translations[lang].passive.length >= 125 ? " small-effect" : "")}>{ this.computeEffect(Library.scalePassiveText(current, current.translations[lang].passive, this.props.level)) }</p>
	            	: <p className={ "game-effect" + (current.effect.length >= 125 ? " small-effect" : "")}>{ this.computeEffect() }</p>
	            }
	            {
	            	champion ? <div className="champion-quote"><span>{current.translations[lang].quote}</span></div> : ""
	            }
	            {
	            	champion &&
	            	<div className="champion-complexity">
	            		<div className="champion-complexity-text">{["simple", "intermediate", "technical"][current.complexity-1]}</div>
	            		<div className="champion-complexity-stars">{"★".repeat(current.complexity) + "☆".repeat(3 - current.complexity)}</div>
	            	</div>
	            }
	            { !champion && maxTier > tier && this.props.onUpgrade && <p className={ "game-effect game-effect-upgrade" + (current.effect.length >= 125 ? " small-effect" : "")}>{ this.computeEffect(current.upgrades[tier].effect) }</p> }
	            {/*<div className="cardbox-side cardbox-left">
	            	{ current.theme ? <div className={"cardbox-sound" + (getMusic() === current.theme ? " active-sound" : "")} onClick={() => { if (getMusic() === current.theme) stopMusic(); else play(current.theme, 'music'); this.forceUpdate(); }}><Img alt="change-music" src="/images/sound.png"/></div> : ""}
	            </div>
	            <div className="cardbox-side cardbox-right">
	             	{(tier > 0 || current.tier > 0) && this.toRoman((tier||current.tier)+1)}
	            </div>*/}
	            { current.health ? <div className="card-stat card-health"><Img className="card-stat-icon" alt="" src={"/images/icons/health.png"}/><div className="card-stat-value">{current.health}</div></div> : "" }
	          	{ this.state.token.length > 0 ? <div className="cardbox-back-to-parent" onClick={() => this.setState({tooltip: null, token: this.state.token.length > 1 ? this.state.token.slice(0, this.state.token.length-1) : [] })}>{ this.state.token.length > 1 ? this.state.token[this.state.token.length-2].name : this.props.src.name }</div> : "" }
	          </div>
	          { this.props.left && this.state.token.length === 0 && !this.state.mask ? <div onClick={() => this.props.left()} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
	          { this.props.right && this.state.token.length === 0 && !this.state.mask ? <div onClick={() => this.props.right()} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
	        </Lightbox>
	        <Lightbox className="cardbox-art-preview" open={this.props.open && !!this.state.artPreview} onClose={() => this.setState({artPreview: null})}>
	        	<Img key={"cardbox-art-preview-" + this.state.artPreview} src={this.state.artPreview} alt=""/>
	        </Lightbox>
	        </>
		);
	}
}
